<template>
    <section class="CaseStudyQuotePullOut" data-speed="1.5">
        <blockquote
            v-if="slice.primary.quote"
            class="CaseStudyQuotePullOut__inner"
        >
            <p>
                {{ slice.primary.quote }}
            </p>
            <footer
                v-if="slice.primary.who_said_it"
                class="CaseStudyQuotePullOut__footer"
            >
                —
                {{ slice.primary.who_said_it }}
            </footer>
        </blockquote>
    </section>
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.NewsPostQuotePulloutSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.CaseStudyQuotePullOut {
    grid-column: 2 / span 22;
    margin-top: 12rem;

    @include large-up {
        margin-top: 7.5rem;
    }
}

.CaseStudyQuotePullOut__inner {
    @include heading-6;

    display: block;
    background-color: var(--lime-green);
    margin-bottom: 2rem;
    padding: 1rem;
    color: var(--black);
    max-width: clamp(37.5rem, 60vw, 50rem);

    p:not(:first-child) {
        margin-top: 1rem;
    }

    @include medium-up {
        @include heading-3;
    }

    @include large-up {
        padding: 2rem;
    }
}

.CaseStudyQuotePullOut__footer {
    @include body-lg;

    font-style: italic;
    margin-top: 1rem;
    margin-bottom: 1rem;
}
</style>
